import {dishLoad, dishNewLoad} from "../../../store/Dish/api";
import {useQuery} from "@tanstack/react-query";
import {getMenu} from "../../../store/Menu/api";
import {toast} from "react-toastify";

export const useGetDish = ({ slug, config }) => {
    return useQuery(["menu-category-dish", slug], () => dishLoad(slug), {
        enabled: !!slug,
        ...config,
        onError: (error) => {
            toast.error(error.response?.data?.message)
        },
    });
}
